/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { WaterQualityCustomizedResultArea } from "./WaterQualityCustomizedResultArea";
import {
  WaterQualityCustomizedResultAreaFromJSON,
  WaterQualityCustomizedResultAreaFromJSONTyped,
  WaterQualityCustomizedResultAreaToJSON,
  WaterQualityCustomizedResultAreaToJSONTyped,
} from "./WaterQualityCustomizedResultArea";

/**
 *
 * @export
 * @interface PaginatedWaterQualityCustomizedResultAreaList
 */
export interface PaginatedWaterQualityCustomizedResultAreaList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<WaterQualityCustomizedResultArea>;
}

/**
 * Check if a given object implements the PaginatedWaterQualityCustomizedResultAreaList interface.
 */
export function instanceOfPaginatedWaterQualityCustomizedResultAreaList(
  value: object
): value is PaginatedWaterQualityCustomizedResultAreaList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedWaterQualityCustomizedResultAreaListFromJSON(
  json: any
): PaginatedWaterQualityCustomizedResultAreaList {
  return PaginatedWaterQualityCustomizedResultAreaListFromJSONTyped(json, false);
}

export function PaginatedWaterQualityCustomizedResultAreaListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedWaterQualityCustomizedResultAreaList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(WaterQualityCustomizedResultAreaFromJSON),
  };
}

export function PaginatedWaterQualityCustomizedResultAreaListToJSON(
  json: any
): PaginatedWaterQualityCustomizedResultAreaList {
  return PaginatedWaterQualityCustomizedResultAreaListToJSONTyped(json, false);
}

export function PaginatedWaterQualityCustomizedResultAreaListToJSONTyped(
  value?: PaginatedWaterQualityCustomizedResultAreaList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(WaterQualityCustomizedResultAreaToJSON),
  };
}
